import apiConfig from "../config/api";
import { get } from "../helpers/request";
import { store } from "../config/store";

const draftApi = `${apiConfig.apiUri}api/complaints/draft`;
const solicitudesApi = `${apiConfig.apiUri}api/complaints`;
const getToken = () => localStorage.getItem("AccessToken");

const getHeader = () => {
  const state = store.getState();

  const header = new Headers({
    "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    Authorization: `Bearer ${getToken()}`,
    USER_ACCESS: JSON.stringify({ companyRut: state.global.companyId }),
  });

  return header;
};


const buildQueryString = function (obj, excluded) {
  const str = [];
  for (const key in obj) {
    if (excluded.includes(key)) continue;

    if (obj.hasOwnProperty(key)) {
      const val = obj[key];

      if (!val || val.toString().trim() === "") continue;

      if (Array.isArray(val)) {
        for (let i = 0, len = val.length; i < len; ++i) {
          const item = val[i];
          str.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
        }
      } else {
        str.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
      }
    }
  }
  return str.join("&");
};
function encodeQueryData(data) {
  const ret = [];
  for (const d in data) { ret.push(`${encodeURIComponent("ducumentsNumber")}=${encodeURIComponent(data[d])}`); }
  return ret.join("&");
}
export const GetSolicitudesApi = (query) => {
  const _query = buildQueryString(query, []);
  return fetch(`${apiConfig.apiUri}api/sel/requests/petitioner/all?${_query}`, {
    method: "GET",
    headers: getHeader(),
  });
};

export const GetSolicitudesApiAuthorized = (query) => {
  const _query = buildQueryString(query, []);
  return fetch(`${apiConfig.apiUri}api/sel/requests/authorized/all?${_query}`, {
    method: "GET",
    headers: getHeader(),
  });
};

export const GetInboxSolicitudesApi = (query) => {
  const _query = buildQueryString(query, []);
  return fetch(`${apiConfig.apiUri}api/sel/requests/callcenter/all?${_query}`, {
    method: "GET",
    headers: getHeader(),
  });
};

export const GetSolicitudesById = (Id) => fetch(`${apiConfig.apiUri}api/sel/requests/${Id}`, {
  method: "GET",
  headers: getHeader(),
});

export const GetWorkersApi = (query) => {
  const _query = encodeQueryData(query);
  return fetch(`${apiConfig.apiUri}api/sel/workers/find?${_query}`, {
    method: "GET",
    headers: getHeader(),
  });
};

export const GetSolicitudesPendientesTrabajador = ({
  CompanyRut, Rut, FechaIni, FechaEnd,
}) =>
  fetch(`${solicitudesApi}/pending`, {
    method: "GET",
    headers: {
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
      RutEmpresa: CompanyRut,
      RutTrabajador: Rut,
      FechaSolicitudInicio: FechaIni,
      FechaSolicitudFin: FechaEnd,
    },
  });

export const GetValidacionTrabajadorEmpresa = ({
  CompanyRut, Rut, Tipo, Fecha,
}) =>
  fetch(`${solicitudesApi}/validationEmployeeCompany`, {
    method: "GET",
    headers: {
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
      RutEmpresa: CompanyRut,
      RutTrabajador: Rut,
      TipoSolicitud: Tipo,
      Fecha,
    },
  });
export const GetDraftComplains = (companyRut, RutUsuario) =>
  fetch(`${draftApi}/${companyRut}/${RutUsuario}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    }
  });

export const DeleteDraftComplaint = (idComplaint) =>
  fetch(`${draftApi}/delete/${idComplaint}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    }
  });

export const listaRoles = (companyId) => get(`${apiConfig.apiUri}api/company/get/employees/${companyId}/roles?roles=PER_SEL_ROL_GESTOR_SEL`);

export const listaTipoExamen = () => get(`${apiConfig.apiUri}api/parameters/tipoexamen`);

export const listaCargos = () => get(`${apiConfig.apiUri}api/parameters/cargos`);

export const listaBaterias = () => get(`${apiConfig.apiUri}api/sel/poolsExams`);

export const listaCargosTipos = (companyId) => get(`${apiConfig.apiUri}api/sel/formData/${companyId}`);

export const listaCentros = () => get(`${apiConfig.apiUri}api/sel/achsoffice/all`);

export const CrearSolicitud = (Data) =>
  fetch(`${apiConfig.apiUri}api/sel/requests`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(Data)
  });

export const GetConfirmacionesApi = (query) => {
  const _query = buildQueryString(query, []);

  return fetch(`${apiConfig.apiUri}api/sel/requests/authorized/all?${_query}`, {
    method: "GET",
    headers: {
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
  });
};

export const GetCallCenterSolicitudesApi = (query) => {
  const _query = buildQueryString(query, []);

  return fetch(`${apiConfig.apiUri}api/sel/requests/callcenter/all?${_query}`, {
    method: "GET",
    headers: {
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
  });
};

export const GetInformacionGeneral = (id) =>

// let _query = buildQueryString(query, []);
// let url = `${apiConfig.apiUri}api/sel/requests/authorized/`+ query.CompanyRut + `/all?${_query}`;

  fetch(`${apiConfig.apiUri}api/sel/requests/${id}`, {
    method: "GET",
    headers: getHeader(),
  });
export const DeleteSolicitudApi = (Data) =>
  fetch(`${apiConfig.apiUri}api/sel/requests/changestatus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(Data)
  });

export const UpdateDataGestionarSolicitud = (Data) =>
  fetch(`${apiConfig.apiUri}api/sel/requests/changestatus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(Data)
  });

export const AgendarCitaApi = (Data) =>
  fetch(`${apiConfig.apiUri}api/sel/workers/scheduling`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(Data)
  });

export const GetInformacionGeneral2 = (id, manage = null) =>
  fetch(`${apiConfig.apiUri}api/sel/selscheduling/requests/${id}` + ((manage !== null && manage === true) ? "?manage=" + manage.toString() : ""), {
    method: "GET",
    headers: getHeader(),
  });

export const GetSchedulingofficeApi = (query) => {
    const _query = buildQueryString(query, []);

    return fetch(`${apiConfig.apiUri}api/sel/selscheduling/schedulingoffice?${_query}`, {
      method: "GET",
      headers: {
        "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
        Authorization: `Bearer ${getToken()}`,
      },
    });
  };

export const UpdateScheduling = (Data) =>
  fetch(`${apiConfig.apiUri}api/sel/selscheduling/workers/scheduling`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(Data)
  });

export const DeleteSchedule = (id) =>
  fetch(`${apiConfig.apiUri}api/sel/selscheduling/workers/scheduling/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    }
  });

export const SaveSchedule = (id) =>
  fetch(`${apiConfig.apiUri}api/sel/selscheduling/workers/scheduling/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    }
  });

  export const GetDatingHorizonApi = (id, year, month) => {
    return fetch(`${apiConfig.apiUri}api/sel/selscheduling/dating/${id}/${year}/${month}`, {
      method: "GET",
      headers: {
        "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
        Authorization: `Bearer ${getToken()}`,
      },
    });
  };
